<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">运输车辆</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>车辆数</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">辆</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Input size="small" v-model="searchMap.keywordA" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 120px">
              <Option value="">按全部方式</Option>
              <Option value="100">按所属公司</Option>
              <Option value="200">按车牌号码</Option>
              <Option value="300">按车辆名称</Option>
            </Select>
          </Input>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.carKind" placeholder="车辆类型">
            <Option value="">车辆类型</Option>
            <Option value="100">新能源自卸车</Option>
            <Option value="600">新能源重型自卸车</Option>
            <Option value="200">新能源勾臂车</Option>
            <Option value="300">四驱燃油自卸车</Option>
            <Option value="400">三轮燃油自卸车</Option>
            <Option value="500">其他</Option>
          </Select>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
         <li>
          <Button type="primary" @click="uploadExcel" size="small" >导出车辆</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="licensePlate">
            <span class="oe1 hotFont13">{{ row.licensePlate }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="carVolume"> {{ row.carVolume }}m³ </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="carKind">
            <span v-if="row.carKind == 100">新能源自卸车</span>
            <span v-if="row.carKind == 600">新能源重型自卸车</span>
            <span v-if="row.carKind == 200">新能源勾臂车</span>
            <span v-if="row.carKind == 300">四驱燃油自卸车</span>
            <span v-if="row.carKind == 400">三轮燃油自卸车</span>
            <span v-if="row.carKind == 500">其他</span>
          </template>
          <!--分割区-->
          <template slot-scope="{ row }" slot="allQualificationsCount">
            <b style="font-size: 18px; color: #01aaed" v-if="row.allQualificationsCount > 0">{{ row.allQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.allQualificationsCount == 0">{{ row.allQualificationsCount }}</b>
            <b style="color: #bbb">/</b>
            <b style="font-size: 18px; color: #ed4014" v-if="row.invalidQualificationsCount > 0">{{ row.invalidQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.invalidQualificationsCount == 0">{{ row.invalidQualificationsCount }}</b>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      pageThis: this,
      loading: false,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "车牌号码",
          key: "licensePlate",
          width: 120,
          align: "center",
          slot: "licensePlate",
        },
        {
          title: "所属单位",
          key: "orgname",
          minWidth: 220,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "车辆类型",
          key: "carKind",
          width: 130,
          slot: "carKind",
          align: "center",
        },
        {
          title: "车辆名称",
          key: "name",
          width: 130,
          align: "center",
        },
        {
          title: "单车载量",
          key: "carVolume",
          width: 80,
          align: "center",
          slot: "carVolume",
        },
        {
          title: "所在区域",
          key: "districtName",
          width: 100,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "所在街道",
          key: "streetName",
          width: 100,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "单位负责人",
          key: "contactName",
          width: 100,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "负责人电话",
          key: "contactTel",
          width: 120,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "资质/异常",
          width: 100,
          align: "center",
          fixed: "right",
          slot: "allQualificationsCount",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),
      searchMap: {
        likeNameA: "",
        keywordA: "",
        carKind: "",
        keyword: "",
        pageNo: 1,
        pageSize: 25,
        code: "",
        level: "",
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
      total: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var parameter = this.searchMap;
      var https = {
        type: "isPagelist",
        api: this.$api.getCarList,
        parameter: parameter,
      };
      this.$httpsApi(https, function (res) {
        that.total = res.count;
        that.dataLoading = true;
      });
    },
 // +----------------------------------------------------------------------
        // | 导出excel
        // +----------------------------------------------------------------------
        uploadExcel() {
            this.$loading(true);
            this.searchMap.ids = this.selectedRows;
            var obj1 = this.searchTemp;
            var obj2 = this.searchMap;
        
            this.searchMap = { ...obj2, ...obj1 };
            
            var parameter = this.searchMap;
            var url = "/zxbigscreen/Car/uploadExcel";
            var fileName = "车辆档案.xlsx";
            this.$downLoad(url,parameter,fileName);
            this.$loading(false);
        },
    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.getList();
    },
  },
};
</script>
